import React, { useEffect, useState } from "react";
import axios from "axios";
import TabComponent from "./TabComponent";
import TableComponent from "./TableComponent";
import { useLocation } from "react-router-dom";
import Loader from "../../assets/img/loader.gif";


function TabTableComponent({
  filterByObj,
  currentPage,
  pageSize,
  bulkAssignId,
  setBulkAssignId,
  handleWonLead,
  setLeadId,
  setModalOpen,
  setModalOpen2,
  setModalOpen3,
  setModalOpen4,
  handlePageChange,
  handlePageSize,
  setAssignedLeadId,
  handleSetEditLead,
  setStageStatus,
  setStatusModalOpen,
  handleLeadStatus,
  setNewStatusLeadId,
  userType,
  status,
  stage,
  applyFilter,
  setLoader,
  loader,
  accountType,
  leadType,
}) {
  const apiUrl = process.env.REACT_APP_URL;
  const Token = localStorage.getItem("_ux98c_v1");

  const [filteredUsers, setFilterUsers] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  //  default tab
  const [linkActive, setLinkActive] = useState("");

  // counts
  const [countWon, setCountWon] = useState(0);
  const [countintergrationInPro, setCountintergrationInPro] = useState(0);
  const [countnegotiation, setCountnegotiation] = useState(0);
  const [countLOST, setCountLOST] = useState(0);
  const [countconatactInFuture, setCountconatactInFuture] = useState(0);
  const [countCallAttempted, setCountCallAttempted] = useState(0);
  const [countproposal, setCountproposal] = useState(0);
  const [countFollowup, setCountFollowup] = useState(0);
  const [countNew, setCountNew] = useState(0);
  const [countOpen, setCountOpen] = useState(0);

  const [applyFilterByReport, setApplyFilterByReport] = useState(false);

  const location = useLocation();

  const leadSourceByReport = location.state?.leadSource;
  const leadStateByReport = location.state?.state;
  const salesAgentByReport = location.state?.salesAgent;
  const salesReportByStage = location.state?.stage;
  const leadOwnerId = location.state?.id;
  const dateTo = location.state?.dateTo;
  const dateFrom = location.state?.dateFrom;

  // MAIN FUNCTION
  const handleStatusChange = async (stageValue) => {

  // ✅ FIX: agar stageValue nahi hai to loader band karke return
  if (!stageValue) {
    setLoader(false);
    return;
  }

  setLoader(true);

  setBulkAssignId([]);

  sessionStorage.setItem("activeTab", stageValue);
  setLinkActive(stageValue);

  const url =
    stageValue === "Open" ||
    stageValue === "Won" ||
    stageValue === "Lost" ||
    stageValue === "All-leads"
      ? `${apiUrl}/lead/getAllMasterLeads/${
          stageValue === "Open" ? "All-leads" : stageValue
        }?leadSource=${filterByObj.leadSource}&leadPipeline=${
          filterByObj.leadPipeline
        }&businessCategory=${
          filterByObj.businessCategory
        }&currentShippingPartner=${filterByObj.partner}&shipmentPotential=${
          filterByObj.shipmentPotential
        }&clientPersona=${filterByObj.clientPersona}&to=${
          dateTo ? dateTo : filterByObj.to
        }&from=${dateFrom ? dateFrom : filterByObj.from}&search=${
          filterByObj.search
        }&isKycDone=${
          filterByObj.isKycDone
        }&minimumExpectedShipmentToFship=${
          filterByObj.minimumExpectedShipmentToFship
        }&employeeId=${
          leadOwnerId ? leadOwnerId : filterByObj.employeeId
        }&genericEmailPattern=${
          filterByObj.genericEmailPattern
        }&state=${leadStateByReport || ""}&page=${currentPage}&pageSize=${pageSize}`
      : `${apiUrl}/lead/getAllLead/${
          stageValue || salesReportByStage
        }?leadSource=${filterByObj.leadSource}&leadPipeline=${
          filterByObj.leadPipeline
        }&businessCategory=${
          filterByObj.businessCategory
        }&currentShippingPartner=${filterByObj.partner}&shipmentPotential=${
          filterByObj.shipmentPotential
        }&clientPersona=${filterByObj.clientPersona}&to=${
          dateTo ? dateTo : filterByObj.to
        }&from=${dateFrom ? dateFrom : filterByObj.from}&search=${
          filterByObj.search
        }&isKycDone=${
          filterByObj.isKycDone
        }&minimumExpectedShipmentToFship=${
          filterByObj.minimumExpectedShipmentToFship
        }&employeeId=${
          leadOwnerId ? leadOwnerId : filterByObj.employeeId
        }&accountType=${accountType}&leadType=${leadType}&genericEmailPattern=${
          filterByObj.genericEmailPattern
        }&page=${currentPage}&pageSize=${pageSize}`;

  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${Token}`,
        "Content-Type": "application/json",
      },
    });

    const data = response.data;

    if (data.status === "success" && Array.isArray(data.data)) {
      setLinkActive(stageValue);
      setFilterUsers(data.data);
      setTotalPages(Math.ceil(data.totalCount / pageSize));

      setCountCallAttempted(data.callAttemted);
      setCountFollowup(data.Followup);
      setCountLOST(data.LOST);
      setCountNew(data.New);
      setCountWon(data.won);
      setCountconatactInFuture(data.conatactInFuture);
      setCountintergrationInPro(data.intergrationInPro);
      setCountnegotiation(data.negotiation);
      setCountproposal(data.proposal);
      setCountOpen(data.Open);

      setApplyFilterByReport(false);
      setStatusModalOpen(false);
    }
  } catch (error) {
    console.error("Error fetching data", error);
  } finally {
    // FINAL FIX: loader hamesha band hoga
    setLoader(false);
  }
};

//   useEffect(() => {
//   const savedTab = sessionStorage.getItem("activeTab");

//   const tab = savedTab || "new";

//   setLinkActive(tab);
//   handleStatusChange(tab);
// }, []);

useEffect(() => {
  const savedTab = sessionStorage.getItem("activeTab") || "Open";
  handleStatusChange(savedTab);
}, []);

 useEffect(() => {
  if (location.state?.stage) {
    const stage = location.state.stage;

    setLoader(false); //IMPORTANT (reset stuck loader)

    setLinkActive(stage);
    handleStatusChange(stage);

    window.history.replaceState({}, document.title);
  }
}, [location.state]);

  
//  useEffect(() => {
//   const savedTab = sessionStorage.getItem("activeTab");

//   if (savedTab) {
//     handleStatusChange(savedTab); // always restore tab
//   } else {
//     handleStatusChange("new"); // first time default
//   }
// }, []);

  // useEffect(() => {
  //   if (linkActive) {
  //     handleStatusChange(linkActive);
  //   }
  // }, [currentPage, pageSize, applyFilter, applyFilterByReport]);

  useEffect(() => {
  const activeTab =
    linkActive || sessionStorage.getItem("activeTab") || "Open";

  handleStatusChange(activeTab);
}, [applyFilter, currentPage, pageSize]);
  
  useEffect(() => {
    if (
      leadSourceByReport ||
      leadStateByReport ||
      salesAgentByReport ||
      salesReportByStage
    ) {
      setApplyFilterByReport((prev) => !prev);
    }
  }, [
    leadSourceByReport,
    leadStateByReport,
    salesAgentByReport,
    salesReportByStage,
  ]);

  // REMOVE RESET BUG
  // useEffect(() => {
  //   if (!sessionStorage.getItem("activeTab")) {
  //     if (stage) {
  //       handleStatusChange(stage);
  //     } else {
  //       handleStatusChange("new");
  //     }
  //   }
  // }, [status, stage]);

  return (
    <div className="col-lg-12">
      <div className="card custom-card">
        <div className="card-body">
          <div className="text-wrap">
            <div className="panel panel-primary tabs-style-3 p-0 tabs-style-3-0">
              <div className="tab-menu-heading">
                <div className="tabs-menu">
                  <TabComponent
                    filterByObj={filterByObj}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    handleStatusChange={handleStatusChange}
                    linkActive={linkActive}
                    // setLinkActive={setLinkActive}
                    countCallAttempted={countCallAttempted}
                    countFollowup={countFollowup}
                    countLOST={countLOST}
                    countNew={countNew}
                    countconatactInFuture={countconatactInFuture}
                    countintergrationInPro={countintergrationInPro}
                    countproposal={countproposal}
                    countWon={countWon}
                    countOpen={countOpen}
                    countnegotiation={countnegotiation}
                    status={status}
                    setLoader={setLoader}
                    loader={loader}
                  />

                  {bulkAssignId.length ? (
                    <a
                      className="btn ripple btn-info btn-sm m-2 text-center"
                      onClick={() => setModalOpen(true)}
                    >
                      Bulk Assign
                    </a>
                  ) : null}

                  {bulkAssignId.length ? (
                    <a
                      className="btn ripple btn-danger btn-sm m-2 text-center"
                      onClick={() => setModalOpen2(true)}
                    >
                      Bulk Source
                    </a>
                  ) : null}

                  {bulkAssignId.length ? (
                    <a
                      className="btn ripple btn-success btn-sm m-2 text-center"
                      onClick={() => setModalOpen3(true)}
                    >
                      Bulk Stage
                    </a>
                  ) : null}

                  {bulkAssignId.length ? (
                    <a
                      className="btn ripple btn-warning btn-sm m-2 text-center"
                      onClick={() => setModalOpen4(true)}
                    >
                      Bulk Pipeline
                    </a>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TableComponent
        userType={userType}
        filteredUsers={filteredUsers}
        handlePageChange={handlePageChange}
        totalPages={totalPages}
        pageSize={pageSize}
        currentPage={currentPage}
        loader={loader}
        handlePageSize={handlePageSize}
        setModalOpen={setModalOpen}
        setAssignedLeadId={setAssignedLeadId}
        handleSetEditLead={handleSetEditLead}
        setStageStatus={setStageStatus}
        setNewStatusLeadId={setNewStatusLeadId}
        setStatusModalOpen={setStatusModalOpen}
        handleLeadStatus={handleLeadStatus}
        setBulkAssignId={setBulkAssignId}
        bulkAssignId={bulkAssignId}
        handleWonLead={handleWonLead}
        setLeadId={setLeadId}
      />

      {loader && (
        <div className="loading-overlay">
          <img src={Loader} alt="Loading..." />
        </div>
      )}
    </div>
  );
}

export default TabTableComponent;